import strings from '../../../strings/strings.json';
import React from 'react';
import { AuthContext } from 'contextProviders/AuthContext';
import { RoleType } from 'models/User';
import LiveCourseDetails from 'components/courseSchedule/LiveCourseDetails';

export default function LiveCourseDetailPage(): JSX.Element {
    const { userData } = React.useContext(AuthContext);

    return (
        <LiveCourseDetails
            backButtonDetails={{
                title:
                    userData.activeRole === RoleType.ORGANISATION_ADMIN
                        ? strings.scheduledCourseDetailsPage.backToDashboardButton.title
                        : strings.scheduledCourseDetailsPage.backToScheduledCoursesButton.title,

                aria:
                    userData.activeRole === RoleType.ORGANISATION_ADMIN
                        ? strings.scheduledCourseDetailsPage.backToDashboardButton.aria
                        : strings.scheduledCourseDetailsPage.backToScheduledCoursesButton.aria,
                href:
                    userData.activeRole === RoleType.ORGANISATION_ADMIN
                        ? '/organisation/dashboard'
                        : '/trainer/dashboard',
                navigateState: { state: { activeTabId: 'liveCourses' } },
            }}
        />
    );
}
